import * as types from '../actions/actionTypes';

export default function deleteApplicationTokenReducer(state = '', action) {
    switch (action.type) {
        case types.DELETE_APPLICATION_TOKEN_SUCCESS:
            return state;
        default:
            return state;
    }
}